import * as React from 'react'
import { Button, Col } from 'antd'
import { injectIntl, IntlShape } from 'react-intl'
import classNames from 'classnames'
import styles from './DeliveryReschedule.module.scss'
import { FadingView, FadingViewChild } from '../FadingView/FadingView'
import { brightness, LightenDarkenColor } from '../../lib/colors'

enum BrightnessThreshold {
  FocusBackground = 123,
  Text = 200
}

interface DeliveryRescheduleProps {
  onRescheduleRequest: VoidFunctionType
  onCancel: VoidFunctionType
  rescheduleRequestSent: boolean
  show: boolean
  color: string
  intl: IntlShape
}

class DeliveryReschedule extends React.Component<DeliveryRescheduleProps> {
  style: CSSStyleDeclaration = document.documentElement.style

  render() {
    const { intl: { formatMessage }, onRescheduleRequest, onCancel, rescheduleRequestSent, show, color } = this.props
    const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
    const colorBrightness = brightness(color)
    const buttonFocusColor = LightenDarkenColor(
      color,
      (colorBrightness > BrightnessThreshold.FocusBackground ? -40 : 40),
    )
    this.style.setProperty('--primary-color', color)
    this.style.setProperty('--button-focus-color', buttonFocusColor)
    this.style.setProperty(
      '--button-text-color',
      (colorBrightness > BrightnessThreshold.Text ? 'black' : 'white'),
    )
    const disabledButtonClassesObject: any = {}
    disabledButtonClassesObject[styles.disabledButton] = rescheduleRequestSent

    return (
      <FadingView pose={show ? 'visible' : 'hidden'}>
        <FadingViewChild>
          <Col xs={24} className={styles.title}>
            {rescheduleRequestSent ? translate('reschedule.title_sent') : translate('reschedule.title')}
          </Col>
        </FadingViewChild>
        <FadingViewChild>
          <Col xs={24} className={styles.subTitle}>
            {translate('reschedule.subtitle')}
          </Col>
        </FadingViewChild>
        <FadingViewChild pose={rescheduleRequestSent ? 'hidden' : 'visible'}>
          <Col xs={24}>
            <Button
              className={classNames(styles.rescheduleButton, disabledButtonClassesObject)}
              onClick={() => onRescheduleRequest()}>
              {translate('reschedule.reschedule_button')}
            </Button>
          </Col>
        </FadingViewChild>
        <FadingViewChild pose={rescheduleRequestSent ? 'hidden' : 'visible'}>
          <Col xs={24} className={styles.cancelButton}>
            <a onClick={onCancel} className={classNames(disabledButtonClassesObject)} role="button">
              {translate('reschedule.cancel_button')}
            </a>
          </Col>
        </FadingViewChild>
      </FadingView>
    )
  }
}

export default injectIntl(DeliveryReschedule)
